module.exports = __webpack_public_path__ + "static/media/support.aef83ae0.svg";